import React from 'react';
import SEOHeadNative from '../components/SEOHeadNative';

const RSE: React.FC = () => {
  return (
    <div>
      <SEOHeadNative
        title="RSE - Responsabilité Sociale et Environnementale - OZARKS ELEC"
        description="Découvrez l'engagement RSE d'OZARKS ELEC : pratiques écoresponsables, matériaux durables, économies d'énergie, formation continue. Électricien responsable à Viesly."
        keywords="RSE électricien, développement durable, écoresponsable, économie énergie, matériaux durables, responsabilité sociale environnementale"
        canonical="/rse"
      />
      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px'}}>
        <div className="t-container">
          <div className="t-col t-col_8 t-prefix_2">
            <div className="t-align_center">
              <h1 className="t-title t-title_xs ozarks-blue-dark">
                Responsabilité <span className="ozarks-blue-medium">Sociétale</span> des Entreprises
              </h1>
              
              <div style={{marginTop: '60px', textAlign: 'left'}}>
                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🌱 Notre engagement environnemental</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Chez OZARKS ELEC, nous nous engageons à respecter l'environnement dans toutes nos activités. 
                    Nous privilégions l'utilisation de matériaux durables et proposons des solutions énergétiques 
                    respectueuses de l'environnement.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🤝 Responsabilité sociale</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Notre entreprise s'attache à maintenir des relations équitables avec tous nos partenaires, 
                    clients et fournisseurs. Nous valorisons le travail local et contribuons au développement 
                    économique de notre région.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>⚡ Innovation et durabilité</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Nous investissons continuellement dans les nouvelles technologies, notamment dans le domaine 
                    des véhicules électriques avec nos installations <strong className="ozarks-blue-medium">IRVE certifiées</strong>. 
                    Notre objectif est de contribuer à la transition énergétique.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🎓 Formation et développement</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    Nous nous engageons à maintenir un haut niveau de compétence grâce à des formations 
                    continues et à une veille technologique constante. Nos <strong className="ozarks-blue-medium">habilitations électriques</strong> sont 
                    régulièrement mises à jour pour garantir la sécurité et la qualité de nos interventions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RSE;